import React, { useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';
import { AuthContext } from 'src/context/AuthContext';
import LoadingView from 'src/views/auth/LoadingView';
import {HarvestingProvider} from 'src/views/harvesting/harvesting-context';
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 48,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  },
  environment:{
    position:'fixed',
    bottom:0,
    right:0,
    background:'#000000AA',
    color:'white',
    padding:theme.spacing(1),
    textTransform:'capitalize'
  }
}));

const DashboardLayout = () => {
  // window.onbeforeunload = (event) => {
  //   if (document.location.hostname !== 'localhost') {
  //     const e = event || window.event;
  //     // Cancel the event
  //     e.preventDefault();
  //     if (e) {
  //       e.returnValue = ''; // Legacy method for cross browser support
  //     }
  //     return ''; // Legacy method for cross browser support
  //   }
  // };

  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const {user} = useContext(AuthContext);

  if (!user) {
    return <LoadingView/>;
  }
  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <HarvestingProvider>
              <Outlet />
            </HarvestingProvider>
          </div>
          <div className={classes.environment} hidden={process.env.REACT_APP_ENV_TYPE==='production'}>
            {process.env.REACT_APP_ENV_TYPE??'Development'} Mode
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
